import { FC, Fragment } from "react";
import { Stack } from "@mui/material";
import { useDidMount } from "rooks";
import { CategoryDrawerHeader } from "./CategoryDrawerHeader";
import { CategoryName } from "./CategoryName";
import { EditingCategory } from "./EditingCategory";
import { CategoryFormActions } from "./CategoryFormActions";
import { EvenSplitAllocationRuleAlertMessage } from "@/components/pages/dimensions/components/form-drawer/components/dimension/categories/EvenSplitAllocationRuleAlertMessage";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { dimensionSharedCostsWithEvenSplitMethodExistsSelector } from "@/store/dimensions/selectors/shared-costs/dimensionSharedCostsWithEvenSplitMethodExistsSelector";
import { initializeSharedCostsThunk } from "@/store/dimensions/thunks/shared-costs/initializeSharedCostsThunk";
import { DimensionStatusAlert } from "@/components/pages/dimensions/components/form-drawer/components/dimension/dimension-components/DimensionStatusAlert";
import { dimensionDrawerModeSelector } from "@/store/dimensions/selectors/slice-data/dimensionDrawerModeSelector";
import { CostAllocationMetadataInCategoryEdit } from "@/components/pages/dimensions/components/form-drawer/components/dimension/cost-allocation/metadata-in-category-edit/CostAllocationMetadataInCategoryEdit";
import { dimensionSharedCostsLengthSelector } from "@/store/dimensions/selectors/slice-data/shared-costs/dimensionSharedCostsLengthSelector";

interface CategoryDrawerFormProps {
  onClose(): void;
}

export const CategoryDrawerForm: FC<CategoryDrawerFormProps> = ({
  onClose,
}) => {
  const dispatch = useAppDispatch();

  const dimensionSharedCostsWithEvenSplitMethodExists = useAppSelector(
    dimensionSharedCostsWithEvenSplitMethodExistsSelector,
  );
  const sharedCostsLength = useAppSelector(dimensionSharedCostsLengthSelector);

  const mode = useAppSelector(dimensionDrawerModeSelector);

  const needToShowAlert =
    mode === "categoryCreate" && dimensionSharedCostsWithEvenSplitMethodExists;

  useDidMount(() => {
    dispatch(initializeSharedCostsThunk());
  });

  return (
    <Fragment>
      <CategoryDrawerHeader onClose={onClose} />

      {needToShowAlert && (
        <Stack p={2} pb={0}>
          <EvenSplitAllocationRuleAlertMessage forceToShowAlert />
        </Stack>
      )}

      <Stack spacing={2} p={2} pb={0}>
        <CategoryName />

        {!!sharedCostsLength && mode === "categoryEdit" && (
          <CostAllocationMetadataInCategoryEdit />
        )}

        <DimensionStatusAlert />

        <EditingCategory />
      </Stack>

      <CategoryFormActions onClose={onClose} />
    </Fragment>
  );
};
